import React, { FC } from "react";
import Image from "next/image";

interface Props {}

export const About: FC<Props> = ({}) => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-10">
        <Image
          src="/images/michal-profile-photo-1.jpg"
          width={180}
          height={180}
          className="rounded-full"
          alt="Michal's profile photo"
        />
      </div>
      <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-5xl">
        <span className="block xl:inline">Hey, I'm Michal 👋</span>{" "}
      </h1>
      <p className="mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
        I am the founder, engineer, designer and customer support of JobsinJS.
      </p>
      <p className="mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
        Over the years of being a software engineer I realised that while there
        are many great jobs out there, they are not always easy to find.
      </p>
      <p className="mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
        My goal with this website is to surface the best JS jobs and companies
        and make it easy for you to find them.
      </p>
      <p className="mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
        You can reach me on{" "}
        <a href="https://twitter.com/michalmalota" className="text-blue-600">
          Twitter
        </a>{" "}
        or{" "}
        <a
          href="https://www.linkedin.com/in/michalmalota/"
          className="text-blue-600"
        >
          Linkedin
        </a>{" "}
        or email me at{" "}
        <a href="mailto:michal@jobsinjs.com" className="text-blue-600">
          michal@jobsinjs.com
        </a>
      </p>
    </div>
  );
};
